// eslint-disable-next-line import/no-extraneous-dependencies
import Swiper from 'swiper/bundle';
import { swiperOptions } from './module/SwiperFunctions';

document.addEventListener('DOMContentLoaded', () => {
  // show__swiper
  if (document.querySelector('.show__swiper.swiper')) {
    // swiper__thumbs
    const thumbs = new Swiper('.show__swiper__thumbs', {
      centeredSlides: false,
      spaceBetween: 10,
      slidesPerView: 'auto',
      touchRatio: 0.2,
      slideToClickedSlide: true,
    });
    new Swiper(
      '.show__swiper',
      swiperOptions({
        thumbs: {
          swiper: thumbs,
        },
        slidesPerView: 1,
        autoplay: 5000,
        loop: true,
        loopedSlides: 6,
        centeredSlides: true,
        disableOnInteraction: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        spaceBetween: 10,
        navigation: {
          nextEl: '.u-swiperButton__next',
          prevEl: '.u-swiperButton__prev',
        },
        pagination: {
          el: '.mainView__swiperPagination',
          bulletClass: 'u-swiperPaginationBullet',
          bulletActiveClass: 'u-swiperPaginationBullet--active',
          clickable: true,
        },
      })
    );
  }

  // layout-4
  if (document.querySelector('.layout-4')) {
    document.querySelectorAll('.layout-4').forEach((layout, index) => {
      // 追加のクラス名を付与
      const newClassName = `layout-4-${index + 1}`;
      layout.classList.add(newClassName);

      const swiperElement = layout.querySelector('.layout-4__swiper');
      const thumbsElement = layout.querySelector('.layout-4__thumbs');

      if (!swiperElement || !thumbsElement) return;

      // 実際のスライド数を取得
      const slidesCount = thumbsElement.querySelectorAll('.swiper-slide').length;
      const loopedSlidesCount = Math.max(slidesCount * 2, 15);

      // サムネイルSwiper
      const thumbsSwiper = new Swiper(thumbsElement, {
        spaceBetween: 10,
        slidesPerView: 3,
        touchRatio: 1, // スワイプ感度を通常に戻す
        loopedSlides: loopedSlidesCount, // 動的に計算した値を使用
        watchSlidesVisibility: true, // 有効化
        watchSlidesProgress: true, // 有効化
        centeredSlides: true,
        navigation: {
          nextEl: layout.querySelector('.layout-4__swiperButton_thumb__next'),
          prevEl: layout.querySelector('.layout-4__swiperButton_thumb__prev'),
        },
      });

      // メインのSwiper
      new Swiper(swiperElement, {
        slidesPerView: 1,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
        spaceBetween: 10,
        loop: true,
        loopedSlides: loopedSlidesCount, // 同じ値を使用
        centeredSlides: false, // `true` だとサムネイルの挙動が不安定になる可能性がある
        thumbs: {
          swiper: thumbsSwiper,
        },
        navigation: {
          nextEl: layout.querySelector('.layout-4__swiperButton__next'),
          prevEl: layout.querySelector('.layout-4__swiperButton__prev'),
        },
      });
    });
  }

  // layout-5
  if (document.querySelector('.layout-5')) {
    document.querySelectorAll('.layout-5').forEach((layout, index) => {
      // 追加のクラス名を付与
      const newClassName = `layout-5-${index + 1}`;
      layout.classList.add(newClassName);

      const swiperElement = layout.querySelector('.layout-5__swiper');
      const thumbsElement = layout.querySelector('.layout-5__thumbs');

      if (!swiperElement || !thumbsElement) return;

      // 実際のスライド数を取得
      const slidesCount = thumbsElement.querySelectorAll('.swiper-slide').length;
      const loopedSlidesCount = Math.max(slidesCount * 2, 15);

      // サムネイルSwiper
      const thumbsSwiper = new Swiper(thumbsElement, {
        spaceBetween: 10,
        slidesPerView: 3,
        touchRatio: 1, // スワイプ感度を通常に戻す
        loopedSlides: loopedSlidesCount, // 動的に計算した値を使用
        watchSlidesVisibility: true, // 有効化
        watchSlidesProgress: true, // 有効化
        centeredSlides: true,
        navigation: {
          nextEl: layout.querySelector('.layout-5__swiperButton_thumb__next'),
          prevEl: layout.querySelector('.layout-5__swiperButton_thumb__prev'),
        },
      });

      // メインのSwiper
      new Swiper(swiperElement, {
        slidesPerView: 1,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
        spaceBetween: 10,
        loop: true,
        loopedSlides: loopedSlidesCount, // 同じ値を使用
        centeredSlides: false, // `true` だとサムネイルの挙動が不安定になる可能性がある
        thumbs: {
          swiper: thumbsSwiper,
        },
        navigation: {
          nextEl: layout.querySelector('.layout-5__swiperButton__next'),
          prevEl: layout.querySelector('.layout-5__swiperButton__prev'),
        },
      });
    });
  }
});
